// react
import React from 'react';
import { FormattedMessage } from 'react-intl';


function ProductTabSpecification({ product }) {

  const specification = product?.specifications
    
    const sections = specification.map((section, index) => {
        const features = section.features.map((feature, index) => (
            <div key={index} className="spec__row">
                <div className="spec__name">{feature.name}</div>
                <div className="spec__value">{feature.value}</div>
            </div>
        ));

        return (
            <div key={index} className="spec__section">
                <h4 className="spec__section-title">{section.name}</h4>
                {features}
            </div>
        );
    });

    return (
        <div className="spec">
            {sections}
            <div className="spec__disclaimer">
                <FormattedMessage id="product.specification.disclaimer" />
            </div>
        </div>
    );
}

export default ProductTabSpecification;
